import Login from './login';
import SignUp from './signUp';

export default {
	Login,
	SignUp
};
